import { render } from "./fullscreenVideo.vue?vue&type=template&id=606f1b6c&scoped=true"
import script from "./fullscreenVideo.vue?vue&type=script&lang=js"
export * from "./fullscreenVideo.vue?vue&type=script&lang=js"

import "./fullscreenVideo.vue?vue&type=style&index=0&id=606f1b6c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\medrina-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606f1b6c"]])

export default __exports__